import logger from 'js-logger';
import request from '../wrapper/auth.request';
import { getLog } from '../wrapper/auth.request.configurator';
import { getUserToken } from '../utils/auth.utils';

/**
 * Init logger
 */
if (logger) {
  logger.useDefaults();
  const log = getLog();
  if (log) logger.setHandler(log);
}

/**
 * Load the user by user token provided by browser.
 *
 * @returns promise
 */
export const getCurrentUser = () => {
  return getUserToken() ? request({ method: 'GET', url: '/users/me' }) : null;
};

/**
 * Request a password confirmation.
 *
 * @param token (the user token)
 * @param newPassword
 * @param confirmPassword
 * @returns promise
 */
export const changeUserPassword = ({ token, newPassword, confirmPassword }) => {
  logger.info('Request a password confirmation.');
  return request({ method: 'POST', url: `/auth/reset/${token}`, data: { newPassword, confirmPassword } });
};

/**
 * Invalidate the user token.
 *
 * @param token
 * @returns promise
 */
export const resetUserPassword = ({ token }) => {
  logger.info('Invalidate the user token.');
  return request({ method: 'GET', url: `/auth/reset/${token}` });
};

/**
 * Send a request of the forgot user password.
 * This action will be sent a e-mail to user confirm a new password.
 *
 * @param email
 * @returns promise
 */
export const forgotUserPassword = ({ email }) => {
  logger.info('Send a request of the forgot user password.');
  return request({ method: 'POST', url: '/auth/forgot', data: { email } });
};

/**
 * Validate the user confirmation token.
 *
 * @param token
 * @returns promise
 */
export const validateUserConfirmationToken = ({ token }) => {
  logger.info('Validate the user confirmation token.');
  return request({ method: 'GET', url: `/auth/confirmation/${token}` });
};

/**
 * Request a user confirmation token.
 *
 * @param email
 * @returns promise
 */
export const requestUserAccountConfirmation = ({ email }) => {
  logger.info('Request a user confirmation token');
  return request({ method: 'POST', url: '/auth/confirmation/', data: email });
};

/**
 * Request to link actual account to social provider.
 *
 * @param provider
 * @param code
 * @param clientId (used only for google link)
 * @param redirectUri
 * @returns promise
 */
export const linkAccountProvider = ({
  provider, code, clientId, redirectUri,
}) => {
  logger.info('Request to link actual account to social provider');
  return request({ method: 'POST', url: `/v2/auth/${provider}`, data: { code, clientId, redirectUri } });
};

/**
 * Request to unlink actual account from social provider.
 *
 * @param provider
 * @returns promise
 */
export const unlinkAccountProvider = ({ provider }) => {
  logger.info('Request to unlink actual account from social provider');
  return request({ method: 'POST', url: '/auth/unlink', data: { provider } });
};
